import type { FilterOption } from 'noddi-ui-web';

/** Title, description and visible options of this filter, for the builder next to its options. */
export const CAR_MODEL_YEAR_FILTER_TEXT = {
  title: 'Model year',
  description: 'Filter by registry model year',
  defaultVisibleOptions: 8
};

const START_YEAR = 1980;

/** Newest first: a car booked today is far likelier to be recent than from 1980. */
const yearOptions = (): FilterOption<number>[] => {
  const endYear = new Date().getFullYear() + 1;
  const years: number[] = [];
  // eslint-disable-next-line no-restricted-syntax -- descending year loop counter
  for (let year = endYear; year >= START_YEAR; year--) {
    years.push(year);
  }
  return years.map((year) => ({ value: year, label: String(year) }));
};

export const CAR_MODEL_YEAR_OPTIONS = yearOptions();
